import { makeAutoObservable } from 'mobx';

export type AudioRecorderState = {
  recording: boolean;
};

export class AudioRecorder {
  private mediaRecorder: MediaRecorder | null = null;

  state: AudioRecorderState = {
    recording: false,
  };

  constructor() {
    makeAutoObservable(this);
  }

  async start() {
    if (this.state.recording) {
      throw new Error('Cannot start a recording while other in progress');
    }

    return new Promise<Blob>((resolve) => {
      (async () => {
        try {
          this.state.recording = true;

          const audioChunks: BlobPart[] = [];
          const stream = await navigator.mediaDevices.getUserMedia({
            audio: true,
          });

          this.mediaRecorder = new MediaRecorder(stream);

          this.mediaRecorder.ondataavailable = (event: BlobEvent) => {
            audioChunks.push(event.data);
          };

          this.mediaRecorder.onstop = async () => {
            const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });
            resolve(audioBlob);
            this.state.recording = false;
          };

          this.mediaRecorder.start();
        } catch (e) {
          this.state.recording = false;
          throw e;
        }
      })();
    });
  }

  stop() {
    this.mediaRecorder?.stop();
  }
}
